import ApiExplorerComponent from "./ApiExplorer/index";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Constants } from "../../utils/constants";
import logger from "../../utils/logger";


/**
 * Wrapper for API Explorer that restricts access to sandbox environments
 */
const ApiExplorer = () => {
  const history = useHistory();

  useEffect(() => {
    // Check if we're in a sandbox environment
    if (!Constants.isSandboxEnvironment()) {
      // Not in sandbox, redirect to dashboard
      logger.warn("API Explorer is only available in sandbox environments");
      history.push("/dashboard");
    }
  }, [history]);

  // Only render the API Explorer if we're in a sandbox environment
  if (!Constants.isSandboxEnvironment()) {
    return null;
  }

  return <ApiExplorerComponent />;
};

export default ApiExplorer;
